var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5188_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 35.75C46.1797 35.75 52 29.9297 52 22.75C52 15.5703 46.1797 9.75 39 9.75C31.8203 9.75 26 15.5703 26 22.75C26 29.9297 31.8203 35.75 39 35.75Z",
    stroke: "#0067B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 68.25V61.75C19.5 58.3022 20.8696 54.9956 23.3076 52.5576C25.7456 50.1196 29.0522 48.75 32.5 48.75H45.5C48.9478 48.75 52.2544 50.1196 54.6924 52.5576C57.1304 54.9956 58.5 58.3022 58.5 61.75V68.25",
    stroke: "#0067B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5188_311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlue);
export default __webpack_public_path__ + "static/media/user-blue.222ab00a8b90719b25f2a785c785d957.svg";
export { ForwardRef as ReactComponent };